'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { useHeaderSearchScroll } from '@/src/components/header/HeaderSearchScroll/useHeaderSearchScroll';
import { InputSearchDestinations } from '@/src/components/input-search-destinations/InputSearchDestinations';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';
import { IIconType } from '@/src/types';

interface IProps {
  destinations: Record<string, IZoneWithDestinationsAndPromo>;
  placeholder: string | null;
  icon: IIconType | null;
  phrase: string | null;
}

export const HeaderSearchScroll = ({
  destinations,
  placeholder,
  icon,
  phrase,
}: IProps) => {
  const pathname = usePathname();
  const { showSearch } = useHeaderSearchScroll();
  const [visible, setVisible] = useState(false);
  const [animationClass, setAnimationClass] = useState('');

  const shouldDisplay = /^\/([a-z]{2}\/)?destinations$/.test(pathname);

  useEffect(() => {
    if (!shouldDisplay) return;

    if (showSearch) {
      setVisible(true);
      setAnimationClass('animate-slide-from-top');
    } else {
      setAnimationClass('animate-slide-to-bottom');
      setVisible(false);
    }
  }, [showSearch, shouldDisplay]);

  if (!visible || !shouldDisplay) return null;

  return (
    <div
      className={`fixed left-0 top-15 z-10 flex w-full justify-center p-4 lg:top-20 lg:bg-primary max-lg:[&_div]:shadow-lg ${animationClass}`}
    >
      <span className="hidden p-4 font-bold text-white lg:inline">
        {phrase}
      </span>
      <InputSearchDestinations
        destinations={destinations}
        placeholder={placeholder}
        icon={icon}
      />
    </div>
  );
};
